import { Host } from '../../index'

const Index = `${Host}admin/plugins/sms/index`
const Add = `${Host}admin/plugins/sms/add`
const Edit = `${Host}admin/plugins/sms/edit`
const Delete = `${Host}admin/plugins/sms/delete`

export default {
    Index,
    Add,
    Edit,
    Delete
}
